import './screen-pager.less';

type ScreenPagerSize = "small" | "big"

interface Props {
  className?: string
  current: number
  total: number
  size?: ScreenPagerSize
}

export default function ScreenPager(props: Props) {
  const { current, total } = props;

  let className = "screen-pager";
  if (props.className) {
    className += " " + props.className;
  }
  
  const size: ScreenPagerSize = props.size || "small"

  className += " " + size

  if ((current > 10 && current < 100) || (total > 10 && total < 100)) {
    className += " c2";
  } else if (current >= 100 || total >= 100) {
    className += " c3";
  }

  return <div className={className} draggable={false}>
    <div className="current" draggable={false}>
      {current}
    </div>
    <div className="divider" draggable={false}>
      /
    </div>
    <div className="total" draggable={false}>
      {total}
    </div>
  </div>
}